module.exports = __webpack_public_path__ + "Poppins-BlackItalic.a40007a5ff53186b4ef3.woff2";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Poppins-BlackItalic.woff2
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Poppins-BlackItalic.woff2
// module chunks = styles